import { createContext, useContext } from "react";

import { type Provider } from "@stacklet/ui";

export const ProviderContext = createContext<Provider>("aws");

export const useProvider = () => {
  const result = useContext(ProviderContext);

  if (!result) {
    throw new Error("ProviderContext used outside of its Provider!");
  }

  return result;
};

const DEFAULT_PROVIDER: Provider = "aws";

let selectedProvider: Provider | null = null;

/**
 * The provider the app shell has selected, for the route loaders that build
 * query variables from it: they run outside React and so can't read the
 * context. `App` owns the value and mirrors it here (see
 * `setSelectedProvider`).
 */
export function getSelectedProvider(): Provider {
  selectedProvider ??= readSavedProvider();
  return selectedProvider;
}

/** Records the shell's selection for the loaders. Called by `App`. */
export function setSelectedProvider(provider: Provider): void {
  selectedProvider = provider;
}

function readSavedProvider(): Provider {
  const saved = localStorage.getItem("provider");

  if (!saved) {
    return DEFAULT_PROVIDER;
  }

  try {
    return JSON.parse(saved) as Provider;
  } catch {
    return DEFAULT_PROVIDER;
  }
}
